import React, { useCallback, useRef, useState } from 'react';
import { Container } from 'components/UI';
import { Title } from '@landing/ui';
import { Slider, SliderControl } from 'components/Slider';
import Slide from './Slide';

import * as styles from './Artists.module.scss';

export default function Artists({ title, slides, theme }) {
  const sliderRef = useRef(null);
  const [current, setCurrent] = useState(1);

  const setCurrentIndex = useCallback((prev, next) => {
    setCurrent(next + 1);
  }, []);

  const handleNext = () => {
    sliderRef.current.slickNext();
  };

  const handlePrev = () => {
    sliderRef.current.slickPrev();
  };

  const settings = {
    fade: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 544,
        settings: {
          adaptiveHeight: true,
        },
      },
    ],
  };

  return (
    <Container id="artists">
      <div className={styles.layout}>
        <div className={styles.top}>
          <Title color="white">{title}</Title>
          {slides.length > 1 && (
            <SliderControl
              className={styles.controls}
              current={current}
              to={slides.length}
              handleNext={handleNext}
              handlePrev={handlePrev}
            />
          )}
        </div>
        <div className={styles.slider}>
          <Slider ref={sliderRef} beforeChange={setCurrentIndex} {...settings}>
            {slides.map(slide => (
              <Slide key={slide.name} theme={theme} {...slide} />
            ))}
          </Slider>
        </div>
      </div>
    </Container>
  );
}
